
import { defineComponent, PropType } from 'vue';
import PostMessageHelper from '@/helpers/PostMessageHelper';
import Background from '@/models/BackgroundModel';

export default defineComponent({
	name: 'widget-header',

	props: {
		title: String,
		background: Object as PropType<Background>,
		isWidgetOpenedAtPhoneScreen: Boolean,
		// Использовать основной цвет как фон вместо предоставленных (Например когда у нас видео фон)
		usePrimaryColorAsBackground: {
			type: Boolean,
			default: false
		},
		popupOpened: {
			type: Boolean,
			default: false
		}
	}
});
